<mat-card class="graphic-card mat-elevation-z4">
    <mat-card-header>
        <mat-card-title>
            <b class="text-truncate">{{ title | translate }}</b>
        </mat-card-title>
        <mat-card-subtitle class="text-truncate">
            {{ subtitle | translate }}
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        <app-graphic-bar *ngIf="data.keys.length > 0 && type == bar" [data]="data"></app-graphic-bar>
        <app-graphic-doughnut *ngIf="data.keys.length > 0 && type == doughnut" [data]="data"></app-graphic-doughnut>
        <app-graphic-line *ngIf="data.keys.length > 0 && type == line" [data]="data"></app-graphic-line>
        <app-graphic-pie *ngIf="data.keys.length > 0 && type == pie" [data]="data"></app-graphic-pie>
    </mat-card-content>
    <mat-card-actions>
        <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>
                <mat-panel-description>{{ "GRAPHIC_REPORT.DETAILS" | translate }}</mat-panel-description>
            </mat-expansion-panel-header>

            <app-graphic-details [data]="data" [export_data]="exportData"></app-graphic-details>
        </mat-expansion-panel>
    </mat-card-actions>
</mat-card>
